'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'

const COOKIE_CONSENT_KEY = 'hive_cookie_consent'

const CookieConsentBanner = () => {
    const [showBanner, setShowBanner] = useState(false)

    useEffect(() => {
        const hasConsented = localStorage.getItem(COOKIE_CONSENT_KEY)
        if ( ! hasConsented) {
            setShowBanner(true)
        }
    }, [])

    const handleClose = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'true')
        setShowBanner(false)
    }

    if ( ! showBanner) return null

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[1000] bg-dark text-white py-8 px-[var(--site-padding)] shadow-lg">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px', maxWidth: '1650px', margin: '0 auto' }}>
                <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-xl text-primary" />
                <span className="text-base">
                    This website utilizes cookies to enable essential site functionality, analytics, personalization and targeted advertising. View the following link to find out more: {' '}
                    <Link href="/hive-modern-cookies-policy" className="underline hover:text-primary">
                        Cookie Policy
                    </Link>
                </span>
                <button
                    type="button"
                    onClick={handleClose}
                    className="hover:text-primary transition-colors ml-auto"
                    aria-label="Close cookie consent banner"
                >
                    <FontAwesomeIcon icon={faXmark} className="text-xl" />
                </button>
            </div>
        </div>
    )
}

export default CookieConsentBanner
